import 'app/page/display.scss';

// import {Router} from 'director';
import {Router} from 'shared/director';
import shared, {ilwRedirect, statsEvent, googlePageView, pageView, config, showSignInModal} from 'shared/shared';
import {$window} from 'shared/util/dom';
import packDisplayPinboard from './includes/pinboard';
import packDisplayCustom from './includes/customize';
import packDisplayActivities from './includes/activities';
import packDisplayActivitiesType from './includes/activitiesType';
import packDisplayStandards from './includes/curriculumStandards';
import ActivitiesPane from "../../shared/activities/activities-pane";
import Api from "../../shared/api";
import AssignedActivityCard from "./includes/AssignedActivityCard";
import QuickAssignActivity from "../../shared/components/quick-assign-activity-modal";
import DuplicateActivity from "../../shared/components/assign-duplicate-modal";
import {
    ActivityRoute,
    PackRoute,
    LearningStrategySnackRoute,
    ClassroomDashboardRoute,
    LearningStrategyRoute,
    LearningStrategyDashboardRoute
} from "../../shared/util/route-constants";
import {trackEvent} from "../../shared/shared";

ilwRedirect(location.pathname);

const packId = window.location.pathname.split('/').remove('').last();
const subjectPath = shared.getSubjectAreaPath();

const views = {
    pinboard: 'pinboard',
    custom: 'custom',
    activities: 'activities',
    standards: 'standards',
    activitiesType: 'activitiesType',
};

const printUrl = ko.observable('');
const downloadUrl = ko.observable('');
const customPackDetail = ko.observable();
const isAssignmentSubmitted = ko.observable(false);
const assignmentSubmittedDate = ko.observable(undefined);
const assignedActivities = ko.observable([]);
const assignment = ko.observable({});
const isDraft = ko.computed(() => {
    return Object.keys(assignment()).length == 0;
});
const isScheduled = ko.computed(() => {
    return assignment().isScheduled;

});
const isOpen = ko.computed(() => {
    return assignment().isOpen;

});

//todo move this to a share file
const normalizeContentType = (contentType) => {
    var result;
    switch (contentType) {
        case 'ARTICLE':
            result = 'article';
            break;
        case 'SUPPLEMENTAL':
            result = 'primarysource';
            break;
        case 'EXCERPT_ARTICLE':
            result = 'excerpt';
            break;
        case 'EXCERPT_SUPPLEMENTAL':
            result = 'excerpt';
            break;
        default:
            result = 'article';
            break;
    }
    return result;
};


function getPrintUrl(){
    $.ajax({
        type: 'GET',
        url: `/${subjectPath}/custom/fetch/pack/pdf/${packId}`,
        success(result) {
            printUrl(result);
        },
    });
}

function getDownloadUrl(){
    downloadUrl(`/${subjectPath}/custom/download/pack/pdf/${packId}`);
}



const urlMakers = {

    edit(item) {
        let contentType = normalizeContentType(item.contentType);

        if (item.contentType == 'EXCERPT_SUPPLEMENTAL' || item.contentType == 'EXCERPT_ARTICLE') {
            return LearningStrategySnackRoute.LEARNING_STRATEGY_EDIT.replace(':packId', packId).replace(':snackId', item.snackId).replace(':contentType', contentType).replace(':contentId', item.savedContentId);
        } else {
            return LearningStrategySnackRoute.LEARNING_STRATEGY_EDIT.replace(':packId', packId).replace(':snackId', item.snackId).replace(':contentType', contentType).replace(':contentId', item.cotentId);
        }

    },

    preview(item) {
        let contentType = normalizeContentType(item.contentType);

        if (item.contentType == 'EXCERPT_SUPPLEMENTAL' || item.contentType == 'EXCERPT_ARTICLE') {
            return LearningStrategySnackRoute.LEARNING_STRATEGY_PREVIEW.replace(':packId', packId).replace(':snackId', item.snackId).replace(':contentType', contentType).replace(':contentId', item.savedContentId);
        } else {
            return LearningStrategySnackRoute.LEARNING_STRATEGY_PREVIEW.replace(':packId', packId).replace(':snackId', item.snackId).replace(':contentType', contentType).replace(':contentId', item.cotentId);
        }

    },


    open(item) {
        let contentType = normalizeContentType(item.contentType);
        if (item.contentType == 'EXCERPT_SUPPLEMENTAL' || item.contentType == 'EXCERPT_ARTICLE') {
            return LearningStrategySnackRoute.LEARNING_STRATEGY_OPEN.replace(':packId', packId).replace(':snackId', item.snackId).replace(':contentType', contentType).replace(':contentId', item.savedContentId);
        } else {
            return LearningStrategySnackRoute.LEARNING_STRATEGY_OPEN.replace(':packId', packId).replace(':snackId', item.snackId).replace(':contentType', contentType).replace(':contentId', item.cotentId);
        }
    },


    student_progress() {
        return LearningStrategyDashboardRoute.ACTIVITES_STUDENT_REVIEW.replace(':packId', packId);
    },


    invite_student(classId) {
        console.log('invite_student', classId);
        return LearningStrategyDashboardRoute.ACTIVITES_INVITE_STUDENT.replace(':classId', classId);
    },
};


function onCustomizeTab() {
    if (config.isLoggedIn()) {
        return true;
    }

    if( config.isLearningStrategy){
        var afterLoginURL = PackRoute.PINBOARD.replace(':packId', packId) + '#/custom';
    } else {
        var afterLoginURL = `${window.location.protocol }//${ window.location.hostname }/${ subjectPath }/${ packId }#/custom`;
    }



    showSignInModal(afterLoginURL);

    return false;
}

const isAllCompleted = ko.observable(false);


function downloadPdf(){
    trackEvent({
        eventName: 'Use Offline',
        eventType: 'Use Offline Button - Modal',
        eventLabel: `Use Offline Modal - ${packId} - ${rawData.pack.text}`

    });
    $('#download-pack-modal').modal('toggle');

    return true;

}

function cancelDownload(){
    trackEvent({
        eventName: 'Use Offline',
        eventType: 'Use Offline Cancel - Modal',
        eventLabel: `Use Offline Cancel - ${packId} - ${rawData.pack.text}`

    });

    return true;

}

const model = {
    views,
    urlMakers,
    LearningStrategyRoute,
    ClassroomDashboardRoute,
    view: ko.observable(''),
    data: ko.observable(null),
    assignedActivities: assignedActivities,
    assignment: assignment,
    isScheduled: isScheduled,
    isAssignmentSubmitted: isAssignmentSubmitted,
    assignmentSubmittedDate:assignmentSubmittedDate,
    isDraft: isDraft,
    isOpen: isOpen,
    printUrl,
    downloadUrl,
    cancelDownload,
    downloadPdf,
    isAllCompleted: isAllCompleted,
    classId:  ko.observable(null),
    studentCount:ko.observable(null),
    quickAssignActivity: ko.observable(new QuickAssignActivity(customPackDetail)),
    duplicateActivity: ko.observable(new DuplicateActivity(customPackDetail)),
    config,
    onCustomizeTab: onCustomizeTab,
};

let router;
let rawData;
let controllers;
let currentController;
let isFirstRoute = true;

function closeDoubleClickDictionary() {
    const $jGrowlClose = $('.jGrowl-close');
    if ($jGrowlClose.length > 0) {
        $jGrowlClose.parent().trigger('jGrowl.close');
    }
}


const trackStatsEvent = () => {

    let urlParts = document.location.hash.slice(2).split('/');

    if (urlParts.length && urlParts[0] === 'pinboard') {

        let eventSubtype = urlParts.length <= 2 ? 'pack-view' : 'resource-view';

        let event = {
            packId,
            eventSubtype
        };

        let resourceId = parseInt(urlParts.pop(), 10);

        if (!!resourceId) {
            event.resourceId = resourceId;
        }

        statsEvent(event);
    }

};

const routes = {
    '/': function () {
        $('.tab-link').tooltip('hide');
        setTimeout(() => {
          $('[data-toggle="tooltip"]').tooltip();
        },50);
        closeDoubleClickDictionary();
        $('body').removeClass('no-scroll');
        $('.no-realtouch .levels a').tooltip('hide');
        if (!isFirstRoute) {
            pageView();
        } else {
            isFirstRoute = false;
        }

        trackStatsEvent();

    },
    '/:view': {
        on: (view, type) => {
            if (views[view]) {

                if (views[view] !== model.view()) {
                    currentController = controllers[view];
                    model.view(views[view]);
                    model.data(currentController.model);
                }
                currentController.init(rawData, packId, type, router);
            }
        },
        '/overlay/assembly/:id': function (view, id) {
            currentController['/assembly/:id'](view, null, id);
        },
        '/:type': {
            on: function (view, _type) {
                currentController['/:type'](view, _type);
            },
            '/overlay/assembly/:id': function (view, _type, id) {
                currentController['/assembly/:id'](view, _type, id);
            }

        }
    },
    // todo revisit for optimization of routes
    '/activities/create/:snackType': {
        on: (snackType) => {
            if (config.isTeacher()) {
                model.data(controllers['activitiesType'].model);
                model.view('activitiesType');
                // filter out non-primary data
                let packItems = rawData.packItems.filter(item => (item.favoriteType === 'ARTICLE' || item.favoriteType === 'EXCERPT' || item.favoriteType === 'ADDITIONALCONTENT') && (item.additionalContentType !== 'MAGAZINE' && item.additionalContentType !== 'WEBSITE' && item.additionalContentType !== 'EBOOK'));
                rawData.filteredPackItems = packItems;
                // filter out the additional source for the activity page ( img, video...)
                controllers['activitiesType'].init(rawData, packId, snackType, router);
            }
        }
    }

};

//Configure Assigned Activity Card

function configureAssignedActivityCard(id, rawData) {

    if (config.isTeacher()) {
        Api.Snack.fetchAllSnacksForTeacher(id).then(
            (data) => {
                if (data.assignment) {
                    model.assignment(data.assignment);

                    // pass assignment( subgroupId ) to quick Assign activity card
                    rawData.assignment = data.assignment;

                }

                if (data.snacks) {
                    data.snacks.forEach((item) => {
                        let assignedActivityCard = new AssignedActivityCard(item);
                        model.assignedActivities(assignedActivities().add(assignedActivityCard));
                    });
                }

                //configure assignment icon
                customPackDetail(rawData);

            }
        )
    } else {
        Api.Snack.fetchAllSnacksForStudent(id).then(
            (data) => {
                if (data.assignment) {
                    model.assignment(data.assignment);

                }

                if (data.snacks) {
                    data.snacks.forEach((item) => {
                        //todo remove later for testing
                        // item.studentResponseStatus = 'COMPLETED';
                        let assignedActivityCard = new AssignedActivityCard(item);
                        model.assignedActivities(assignedActivities().add(assignedActivityCard));
                    })

                }

                if (data.submittedDate && data.submittedDate > 0) {
                    isAssignmentSubmitted(true);
                    assignmentSubmittedDate(data.submittedDateExecutionRegionString);
                }


                /*
                check if all the student snack is completed or not, and it is default to false;
                 */
                for (let i = 0; i < data.snacks.length; i++) {
                    if (data.snacks[i].studentResponseStatus !== 'COMPLETED') {
                        break;
                    } else {
                        if (i === (data.snacks.length - 1)) {
                            isAllCompleted(true);
                        }
                    }
                }

            }
        )

    }


}

function init() {
    shared.initShared();

    getPrintUrl();
    getDownloadUrl();

    controllers = {
        'pinboard': packDisplayPinboard,
        'custom': packDisplayCustom,
        'activities': packDisplayActivities,
        'standards': packDisplayStandards,
        'activitiesType': packDisplayActivitiesType,
    };

    model.user = {
        id: shared.getIndividualId(),
        name: shared.getIndividualName()
    };

    $.getJSON(`/${subjectPath}/snackPack/get/classInfo/packId/${packId}`).done((data) => {

        model.classId(data.classId);
        model.studentCount(data.studentCount);
    });


    $.getJSON(`/${subjectPath}/custom/pack?packId=${packId}`).done((data) => {
        if (config.isActivity) {

            const activitiesPane = ko.observable(new ActivitiesPane(data));

            packDisplayCustom.model.activitiesPane = activitiesPane;
            packDisplayPinboard.model.activitiesPane = activitiesPane;
        }

        rawData = data;

        // console.log(111, );

        router = new Router(routes).configure({
            strict: false,
            recurse: 'forward'
        });
        // router = new Router(routes);

        router.init('/pinboard');



        // router.init('/pinboard');
        // only fetch it when it is learning stratgey page, the indicator is passed from jsp

        if (window.__packData && window.__packData.isLearningStrategy !== 'false') {
            configureAssignedActivityCard(packId, data);
        } else {
            //configure assignment icon which doesn't subgroupId
            customPackDetail(data);
        }
        // ko.cleanNode(document.querySelector('.pinboard.pack-display'));
        ko.applyBindings(model, document.querySelector('.pinboard.pack-display'));


    });
}

init();



// WEBPACK FOOTER //
// ./javascript/app/page/display/display.js